import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import HeaderComponent from '../components/General/HeaderComponent';
import MenuBarComponent from '../components/Panel/MenuBarComponent';
import MindMapEditor from '../components/MindMap/MindMapEditor';

const MindMap = () => {
  const { id } = useParams();
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mindMapData, setMindMapData] = useState(null);

  useEffect(() => {
    // Proje verilerini yükle (gelecekte API'den gelecek)
    const fetchProjectData = async () => {
      try {
        setLoading(true);
        // Şimdilik mock data
        setProjectData({
          pname: `Proje ${id}`,
          pdesc: 'Mind Map sayfası',
          created_at: new Date().toISOString(),
          userstatus: 11 // Admin
        });
      } catch (error) {
        console.error('Proje verileri yüklenirken hata:', error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchProjectData();
    }
  }, [id]);

  const handleSaveMindMap = (data) => {
    setMindMapData(data);
    
    // Burada API'ye gönderebilirsiniz
    // await saveMindMapToAPI(id, data);
    
    alert('Mind Map başarıyla kaydedildi!');
  };

  if (loading) {
    return (
      <div className="w-full dark:bg-dark-100 bg-stone-100 min-h-screen">
        <div className="container mx-auto">
          <div className="flex justify-center items-center h-96">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-600"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full dark:bg-dark-100 bg-stone-100 min-h-screen">
      <div className="container mx-auto">
        <HeaderComponent title={projectData?.pname || `Proje ${id}`} />
        <MenuBarComponent title="mind-map" />
        
        {/* Mind Map İçeriği - Tam genişlik */}
        <div className="bg-white dark:bg-dark-200 rounded-xl shadow-sm border border-gray-200 dark:border-dark-300 mb-6 h-[calc(100vh-200px)]">
          <div className="h-full">
            <MindMapEditor 
              onSave={handleSaveMindMap}
              initialData={mindMapData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MindMap;
